import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { SubmitEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsFormTechnicalVisitApi extends ComponentAPI<any> {

  /** @event */
  @AwesomeEvent
  onSubmit = new SubmitEventListener();

  setEditing(s: boolean): void {
    this.setState({ editing: s, locked: !s, disabled: !s });
  }

  setLocked(locked: boolean): void {
    this.setState({ locked: locked, disabled: locked });
  }

}
